import { pageT } from '../i18n/page.i18n';

export const PAGE_BLOCK_TITLES = {
    videoUpload: {
        full: pageT('videoUploadFull'),
        short: pageT('videoUploadShort'),
    },
    videoList: {
        full: pageT('videoListFull'),
        short: pageT('videoListShort'),
    },
};
